import { FormlyFieldConfig } from "@ngx-formly/core";
import { Injector } from "@angular/core";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeRoutesOfAdministrationList } from "../../../Art57Node/ListEntity/TreeNodeRoutesOfAdministrationList";
import { TreeNodeAttachmentList } from "../../../Art57Node/ListEntity/TreeNodeAttachmentList";

export class AttachmentQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).attachmentFields;
    const createChidTemplateParams = {nodeType: 1};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).attachmentConditions;
       super(injector, [], 'Attachments', EntityEnum.attachment,  queryFields, queryConditions,injector.get(Art57Section).medicinalProduct.attachmentTreeNode,TreeNodeAttachmentList,AutoUploadEntityEnum.attachment, createChidTemplateParams);       
    }
}